<template>
	<view class="header">
		<slot></slot>
	</view>
</template>

<script>
	export default {
		name:"Header"
	}
</script>

<script setup>
</script>

<style scoped>
	/* .header{
		border: 1px red solid;
	} */
</style>